import { useDispatch, useSelector } from "react-redux";
import { uploadFileAction } from "../../../redux/actions/GlobalAction";
import {
  AllowedFile,
  AllowedFileText,
  AllowedFileText12MB,
  getSnackbarSuccess,
  MandatoryStar,
} from "../../../Utils/helper";
import { removeImageHandler } from "./commonfunctionality";

export const ImageUploadRemoveComponent = ({
  imageDetails,
  heading,
  docType,
  setIsImageOpen,
  setImagePath,
  getPageAPI,
  required,
  fileSize,
}) => {
  const dispatch = useDispatch();
  const isPageEdit = useSelector((state) => state?.globalReducer?.isPageEdit);
  return (
    <div className="col-md-6 mt-4">
      <div className="upload-document">
        <h4 style={{ marginBottom: "20px", fontSize: "16px" }}>
          {heading}
          {required && <MandatoryStar />}
        </h4>
        <div className="d-flex align-items-center mt-3">
          <div className="upload-file">
            <div className="upload-file__btn d-flex">
              {(imageDetails === undefined || imageDetails?.urlPath === "") && (
                <>
                  <label>
                    <input
                      type="file"
                      id="imageUpload"
                      accept={AllowedFile}
                      style={{ width: "2px" }}
                      name={docType}
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (file.size > fileSize) {
                          getSnackbarSuccess(
                            "info",
                            `Maximum upload file size is ${
                              fileSize === 2097152 ? "2" : "12"
                            } MB.`,
                            dispatch
                          );
                        } else if (
                          file.type !== "image/jpg" &&
                          file.type !== "image/jpeg" &&
                          file.type !== "image/png" &&
                          file.type !== "application/pdf"
                        ) {
                          getSnackbarSuccess(
                            "info",
                            "File Types allowed are JPG, JPEG, PNG or PDF.",
                            dispatch
                          );
                        } else {
                          await dispatch(
                            uploadFileAction(
                              e.target.files[0],
                              docType,
                              dispatch
                            )
                          );
                          await dispatch(getPageAPI());
                        }
                      }}
                      disabled={!isPageEdit}
                      required={required}
                    />
                    <span style={{ cursor: !isPageEdit && "auto" }}>
                      <img src="./images/uploadicon.svg" alt="" /> UPLOAD
                    </span>
                  </label>
                  {fileSize === 2097152 ? (
                    <AllowedFileText topmargin="0px" />
                  ) : (
                    <AllowedFileText12MB topmargin="0px" />
                  )}
                </>
              )}
            </div>
          </div>
          {imageDetails !== undefined && imageDetails?.urlPath !== "" && (
            <div style={{ display: "flex" }}>
              {imageDetails?.urlPath?.includes(".pdf") ||
              imageDetails?.imageUrl?.includes(".pdf") ? (
                <a href={imageDetails?.urlPath || imageDetails?.imageUrl}>
                  {heading.replace(/\s/g, "_").toLowerCase()}
                  .pdf
                </a>
              ) : (
                <div>
                  <img
                    src={imageDetails?.urlPath || imageDetails?.imageUrl}
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      cursor: "pointer",
                    }}
                    type="button"
                    onClick={() => {
                      setIsImageOpen(true);
                      setImagePath(
                        imageDetails?.urlPath || imageDetails?.imageUrl
                      );
                    }}
                    alt=""
                  />
                </div>
              )}
              {isPageEdit && (
                <div className="ms-4" style={{ margin: "auto" }}>
                  <img
                    src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png"
                    type="button"
                    onClick={async () => {
                      await removeImageHandler(
                        imageDetails,
                        getPageAPI,
                        true,
                        dispatch
                      );
                    }}
                    alt=""
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
